export enum PaginationMessages {
  NextPageLabel = 'Next',
  PreviousPageLabel = 'Previous',
  NoDataLabel = 'No results found, use the search bar to get any results.',
}
